import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const hcssConfig: TSPConfig = {
  key: 'hcss',
  name: 'HCSS',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        Follow the instructions at{' '}
        <a
          href='https://developer.hcssapps.com/getting-started/get-credentials/'
          target={'_blank'}
          rel='noreferrer'
        >
          here
        </a>{' '}
        to generate the client credentials.
      </p>
      <ol>
        <li>
          In the HCSS Credentials Portal{' '}
          <a
            href='https://hcssapps.com/ApiAdmin/RequestApiCredentials'
            target={'_blank'}
            rel='noreferrer'
          >
            here
          </a>
          , go to the Product Setup &gt; API &gt; Client ID and Secret.
        </li>
        <li>
          Click on Add Client, select the users and telematics read permission
          scopes, and then click Generate Client.
        </li>
        <li>
          Only add scopes you have granted to the client or your request will be
          rejected.
        </li>
        <li>
          Example scope: <code>telematics:read users:read</code>
        </li>
        <li>
          Copy the generated client ID and secret here. You will not be able to
          see these again, so please copy them carefully.
        </li>
      </ol>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[
        { label: 'Client ID', name: 'database', type: 'text', required: true },
        {
          label: 'Client Secret',
          name: 'authorizationcode',
          type: 'password',
          required: true,
        },
        { label: 'Scope', name: 'carriername', type: 'text', required: true },
      ]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default hcssConfig;
